<template>
  <div class="navbar">
    <div class="logo">
      <div class="jump" @click="toIndex()">
        <img style="height: 30px" src="../assets/logoNew.png" />
      </div>
      <div class="headLine"></div>
      <img src="../assets/new/circle@2x.png" class="backIcon" @click="toIndex()" />

      <div class="typeActiveList" v-if="
        (!$route.query.token ||
          $route.query.channelId !== undefined ||
          $route.query.postJump == 1) &&
        showBtn
      ">
        <div class="typePickItem" :class="{ typeActive: showText == item.name }" v-for="(item, index) in typeOption"
          :key="index" @click="typePickFn(item.type)">
          发布{{ item.name }}
        </div>
      </div>
    </div>

    <BanDialog ref="banShow" :isShow="isBanned" :allowClose="true" @closeBan="isBanned = false"></BanDialog>
  </div>
</template>

<script>
import BanDialog from "../components/banDialog.vue";

export default {
  name: "NavBar",
  data() {
    return {
      typeOption: [
        {
          type: 1,
          name: "文章",
        },
        {
          type: 2,
          name: "视频",
        },
        {
          type: 3,
          name: "图集",
        },
        {
          type: 6,
          name: "帖子",
        },
      ],
      typeNow: 1,
      tokenQuery: {},
      isBanned: false,
      showText: "",
    };
  },
  components: {
    BanDialog,
  },
  created() {
    this.typeNow = this.type;
    this.tokenQuery = JSON.parse(JSON.stringify(this.$route.query));
    if (this.type == 6) {
      this.showText = this.typeOption[3].name;
    } else if (this.type == 4) {
      this.showText = this.typeOption[4].name;
    } else {
      this.showText = this.typeOption[this.type - 1].name;
    }
  },
  props: {
    type: {
      type: Number,
      default: () => 1,
    },
    showBtn: {
      type: Boolean,
      default: () => true,
    },
  },
  methods: {
    toIndex() {
      if (
        !this.$route.query.token ||
        this.$route.query.channelId !== undefined ||
        this.$route.query.postJump == 1
      ) {
        this.$router.push({ path: "/index", query: {} });
      }
    },
    isEmptyObject(obj) {
      delete obj.token;
      for (var key in obj) {
        return false;
      }
      return true;
    },
    typePickFn(index) {
      this.typeNow = index;

      if (this.typeNow != this.type) {
        let path = "";
        switch (this.typeNow) {
          case 1:
            path = "/scriptWrite";
            break;
          case 2:
            path = "/videoWrite";
            break;
          case 3:
            path = "/graphWrite";
            break;
          case 4:
            path = "/videoWrite?isPack=1";
            break;
          case 6:
            path = "/post";
            break;
        }

        if (localStorage.getItem("banData")) {
          let banData = JSON.parse(localStorage.getItem("banData"));
          if (
            (this.typeNow == 6 &&
              banData.ban_type == 1 &&
              banData.ban_range_type.indexOf("3") > -1) ||
            (this.typeNow != 6 &&
              banData.ban_type == 1 &&
              banData.ban_range_type.indexOf("1") > -1)
          ) {
            this.$refs.banShow.getReason(localStorage.getItem("token"));
            this.isBanned = true;
            return;
          }
        }

        if (
          this.isEmptyObject(this.$route.query) ||
          this.$route.query.channelId !== undefined ||
          this.$route.query.isPack
        ) {
          let thisQuery = this.$route.query;
          delete thisQuery.isPack;
          if (window.location.href.split("token=")[1]) {
            thisQuery.token = window.location.href
              .split("token=")[1]
              .replace("%3A", ":");
          }
          this.$router.push({ path: path, query: thisQuery });

          if (this.type == 6) {
            this.showText = this.typeOption[3].name;
          } else if (this.type == 4) {
            this.showText = this.typeOption[4].name;
          } else {
            this.showText = this.typeOption[this.type - 1].name;
          }
        } else {
          let routeData = this.$router.resolve({
            path: path,
            query: {},
          });
          window.open(routeData.href, "_blank");

          this.typeNow = this.type;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 60px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  width: 100%;
  box-sizing: border-box;

  .logo {
    padding-left: 48px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    line-height: 84px;
    background: #fff;
    color: #002140;

    .jump {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .headLine {
      width: 2px;
      height: 32px;
      background: #edf1f8;
      margin: 0 20px;
    }

    .backIcon {
      height: 24px;
      cursor: pointer;
    }

    .typeActiveList {
      display: flex;

      .typePickItem {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        margin-left: 24px;
        cursor: pointer;
      }

      .typeActive {
        color: #f32432;
      }
    }
  }
}
</style>
